import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomNavbar from "../../../components/CustomNavbar";
//import SibebarSeleccionContratacion from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";
import comp from "../../../images/formacion.png";
import { useSelector } from "react-redux";
const Admin = () => {
  const [show, setShow] = useState(true);
  const userRoles = useSelector((store) => store.auth.userRoles);
  //* Method
  const onShowSidebar = () => setShow(show ? false : true);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="jumbotron ft-banner">
            <main>
              <h1>ADMINISTRACIÓN DE CAPACITACIÓN Y DESARROLLO</h1>
              <p className="mb-4 text-muted">
                Desde este espacio podrás realizar las configuraciones del
                módulo de capacitación y desarrollo
              </p>
              {/*<Link s
              to='/seleccion-contratacion/administracion/motivos-plazas-vacantes'
              className="btn btn-primary rounded-pill">Agregar motivo de plaza vacante</Link>*/}
              {/* <Button variant="primary" className="rounded-pill"> */}
              <Link
                className="btn btn-primary rounded-pill"
                to="/capacitacion-desarrollo/rutas-capacitacion"
              >
                Campañas de capacitación
              </Link>
              {/* </Button> */}
              <br />
              <br />
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/modalidades">
                    Modalidades
                  </Link>
                </li>
              ) : null}
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/tipo-capacitacion">
                    Tipo de capacitación
                  </Link>
                </li>
              ) : null}
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/origines">Orígenes</Link>
                </li>
              ) : null}
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/motivos-inasistencia">
                    Motivos de inasistencia
                  </Link>
                </li>
              ) : null}
              {/* {userRoles.length > 0 && (userRoles.includes("administrador")||userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/estados">Estados</Link>
                </li>
              ) : null} */}
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/capacitaciones">
                    Capacitaciones
                  </Link>
                </li>
              ) : null}
              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/enfoques">Enfoques</Link>
                </li>
              ) : null}

              {userRoles.length > 0 &&
              (userRoles.includes("administrador") ||
                userRoles.includes("Responsable_Capacitacion")) ? (
                <li>
                  <Link to="/capacitacion-desarrollo/metrica-evaluacion-factor">
                    Métrica de evaluación por factor
                  </Link>
                </li>
              ) : null}
            </main>
            <div className="figure">
              <img src={comp} alt="descriptores y perfiles" />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Admin;
